import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";
import {
  leavesRequestDelete,
  leavesRequests,
  leaveStatusUpdate,
} from "../../../api/Holidays";
import { formatToDate } from "../../master/FormatToDateTime";
import Swal from "sweetalert2";
import usePrivateLink from "../../config/usePrivateLink";
import Pagination from "../../components/Pagination";

export default function LeaveRequest() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({
    type: "student",
    page: 1,
    status: "0",
  });

  const getLeavesList = async () => {
    setLoading(true);

    let addUrl = new URLSearchParams(filters).toString();

    try {
      const response = await leavesRequests(addUrl);

      if (response?.data?.status === true) {
        setData(response?.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this leave request!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await leavesRequestDelete(id);

          if (response?.data?.status === true) {
            SweetAlertShow("success", "Deleted", response?.data?.message);
            getLeavesList();
          } else {
            SweetAlertShow("info", "Warning", response?.data?.message);
          }
        } catch (err) {
          SweetAlertShow(
            "error",
            "Error",
            err?.response?.data?.message ?? err?.message,
          );
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleStatusChange = (id, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to change status?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await leaveStatusUpdate({ id, status });

          if (response?.data?.status === true) {
            SweetAlertShow("success", "Success", response?.data?.message);
            getLeavesList();
          } else {
            SweetAlertShow("info", "Warning", response?.data?.message);
          }
        } catch (err) {
          SweetAlertShow(
            "error",
            "Error",
            err?.response?.data?.message ?? err?.message,
          );
        } finally {
          setLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    getLeavesList();
  }, [filters]);

  const hasAccess = usePrivateLink();
  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card-body">
                      <div className="row">
                        <div className="card p-3">
                          {/* Header */}

                          <h5 className="text-primary m-0">Leaves Requests</h5>
                          <div className="">
                            <button
                              className={`btn btn-sm me-2 ${filters.type === "student"
                                ? "btn-primary"
                                : "btn-outline-primary"
                                }`}
                              onClick={() =>
                                setFilters({
                                  ...filters,
                                  type: "student",
                                  page: 1,
                                })
                              }
                            >
                              Student
                            </button>

                            <button
                              className={`btn btn-sm ${filters.type === "staff"
                                ? "btn-primary"
                                : "btn-outline-primary"
                                }`}
                              onClick={() =>
                                setFilters({
                                  ...filters,
                                  type: "staff",
                                  page: 1,
                                })
                              }
                            >
                              Staff
                            </button>
                          </div>

                          {/* Search Row */}
                          <div className="row mt-3">
                            <div className="col-lg-4 col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search by Name / Reg No"
                                  value={filters?.search || ""}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      search: e.target.value.toUpperCase(),
                                      page: 1,
                                    })
                                  }
                                />
                                <label>Search by Name / Reg No</label>
                              </div>
                            </div>

                            {/* 📅 From Date */}
                            <div className="col-lg-3 col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="date"
                                  className="form-control"
                                  value={filters?.from_date || ""}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      from_date: e.target.value,
                                      page: 1,
                                    })
                                  }
                                />
                                <label>From Date</label>
                              </div>
                            </div>

                            {/* 📅 To Date */}
                            <div className="col-lg-3 col-sm-6">
                              <div className="form-floating form-floating-outline">
                                <input
                                  type="date"
                                  className="form-control"
                                  value={filters?.to_date || ""}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      to_date: e.target.value,
                                      page: 1,
                                    })
                                  }
                                />
                                <label>To Date</label>
                              </div>
                            </div>
                            <div className="mt-3">
                              <button
                                className={`btn btn-sm me-2 ${filters.status === "0" ? "btn-warning" : "btn-outline-warning"
                                  }`}
                                onClick={() =>
                                  setFilters({
                                    ...filters,
                                    status: "0",
                                    page: 1,
                                  })
                                }
                              >
                                Pending
                              </button>

                              <button
                                className={`btn btn-sm me-2 ${filters.status === "1" ? "btn-success" : "btn-outline-success"
                                  }`}
                                onClick={() =>
                                  setFilters({
                                    ...filters,
                                    status: "1",
                                    page: 1,
                                  })
                                }
                              >
                                Approved
                              </button>

                              <button
                                className={`btn btn-sm ${filters.status === "2" ? "btn-danger" : "btn-outline-danger"
                                  }`}
                                onClick={() =>
                                  setFilters({
                                    ...filters,
                                    status: "2",
                                    page: 1,
                                  })
                                }
                              >
                                Rejected
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="card mt-5 col-12">
                          <div className="table-responsive">
                            <table className="table table-hover">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Name/Reg.</th>
                                  <th>Mobile</th>
                                  <th>Date</th>
                                  <th>Title</th>
                                  <th>Remark</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data?.data?.map((item, i) => (
                                  <tr key={item.id}>
                                    <td>{i + 1}</td>
                                    <td>
                                      {item?.type === "student"
                                        ? `${item?.student?.name} (${item?.student?.registration_no})`
                                        : `${item?.staff?.name} (${item?.staff?.registration_no})`}
                                    </td>
                                    <td>
                                      {item?.type === "student"
                                        ? item?.student?.phone
                                        : item?.staff?.mobile}
                                    </td>
                                    <td>{formatToDate(item?.date)}</td>
                                    <td>{item?.title}</td>
                                    <td>{item?.description}</td>
                                    <td>
                                      <div
                                        className={`p-1 rounded ${item?.status === "1"
                                          ? "border border-success text-success"
                                          : item?.status === "2"
                                            ? "border border-danger text-danger"
                                            : "border border-warning text-warning"
                                          }`}
                                      >
                                        <select
                                          className={`form-select form-select-sm border-0 shadow-none ${item?.status === "1"
                                            ? "text-success"
                                            : item?.status === "2"
                                              ? "text-danger"
                                              : "text-warning"
                                            }`}
                                          value={item?.status}
                                          onChange={(e) =>
                                            handleStatusChange(
                                              item?.id,
                                              e.target.value,
                                            )
                                          }
                                        >
                                          <option value="0">Pending</option>
                                          <option value="1">Approved</option>
                                          <option value="2">Rejected</option>
                                        </select>
                                      </div>
                                    </td>
                                    <td>
                                      {hasAccess("/leave/request/delete") && (
                                        <button
                                          className="btn btn-sm mx-1 btn-label-danger"
                                          onClick={() => handleDelete(item?.id)}
                                        >
                                          <i className="ri-delete-bin-line"></i>
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            <Pagination
                              data={data}
                              filters={filters}
                              setFilters={setFilters}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
